import {TweenMax, Cubic} from 'gsap';
const TimelineUnit = require('./TimelineUnit');
const EventEmitter = require('eventemitter3');
const Utils = require('../utils/utils');

/* INTERNAL FUNCTIONS */

const _getUnit = (d, create, destroy, creationDelta) => {
    const unit = new TimelineUnit(create, destroy, d);
    if (creationDelta !== void 0) unit.creationDelta = creationDelta;
    return unit;
}

const _updateDuration = (tl, t1) => {
    if (tl.duration > t1) return tl.duration;
    tl.duration = t1;
    return t1;
}

const _setTimeHash = (tl, t, d, creationDelta, index) => {
    __pushToAscendingArray({index: index, t: t - creationDelta}, tl._createHash.forth.todo, 't');
    __pushToAscendingArray({index: index, t: t + d + creationDelta}, tl._createHash.back.done, 't');

    __pushToAscendingArray({index: index, t: t + d + creationDelta}, tl._deleteHash.forth.todo, 't');
    __pushToAscendingArray({index: index, t: t - creationDelta}, tl._deleteHash.back.done, 't');

    __pushToAscendingArray({index: index, t: t}, tl._startHash.forth.todo, 't');
    __pushToAscendingArray({index: index, t: t + d}, tl._startHash.back.done, 't');
}

const __pushToAscendingArray = (value, array, param) => {
    let i = array.length - 1;
    if (i < 0) {
        array.push(value);
        return;
    }
    while (i > -1 && value[param] < array[i][param]) {
        i--;
    }
    if (i < 0) {
        array.unshift(value);
        return;
    }
    array.splice(i + 1, 0, value);
}

/* const __resetTimeHashToDo = obj => {
    obj.todo = __getMergedTimeHash(obj);
    obj.done.splice(0, obj.done.length);
}

const __resetTimeHashToDone = obj => {
    obj.done = __getMergedTimeHash(obj);
    obj.todo.splice(0, obj.todo.length);
}

const __getMergedTimeHash = obj => {
    return obj.sign < 0 ? obj.todo.concat(obj.done) : obj.done.concat(obj.todo);
}

const _resetTimeHashToTheBegining = tl => {
    __resetTimeHashToDo(tl._createHash.forth);
    __resetTimeHashToDone(tl._createHash.back);

    __resetTimeHashToDo(tl._deleteHash.forth);
    __resetTimeHashToDone(tl._deleteHash.back);

    __resetTimeHashToDo(tl._startHash.forth);
    __resetTimeHashToDone(tl._startHash.back);
}

const _resetTimeHashToTheEnd = tl => {
    __resetTimeHashToDone(tl._createHash.forth);
    __resetTimeHashToDo(tl._createHash.back);

    __resetTimeHashToDone(tl._deleteHash.forth);
    __resetTimeHashToDo(tl._deleteHash.back);

    __resetTimeHashToDone(tl._startHash.forth);
    __resetTimeHashToDo(tl._startHash.back);
}*/


const _updateHashForth = (obj, value, param) => {
    let arrFrom;
    let arrTo;

    if (obj.sign > 0) {
        arrFrom = obj.todo;
        arrTo = obj.done;
    } else {
        arrFrom = obj.done;
        arrTo = obj.todo;
    }

    return _moveSmallerValues(arrFrom, arrTo, value, param);
}

const _updateHashBack = (obj, value, param) => {
    let arrFrom;
    let arrTo;

    if (obj.sign > 0) {
        arrFrom = obj.done;
        arrTo = obj.todo;
    } else {
        arrFrom = obj.todo;
        arrTo = obj.done;
    }

    return _moveLargerValues(arrFrom, arrTo, value, param);
}

const _moveSmallerValues = (arrFrom, arrTo, value, param) => {
    const ids = [];
    while (arrFrom.length > 0 && value > arrFrom[0][param]) {
        ids.push(arrFrom[0].index);
        arrTo.push(arrFrom.shift());
    }
    return ids;
}

const _moveLargerValues = (arrFrom, arrTo, value, param) => {
    const ids = [];
    while (arrFrom.length > 0 && value < arrFrom[arrFrom.length - 1][param]) {
        ids.push(arrFrom[arrFrom.length - 1].index);
        arrTo.unshift(arrFrom.pop());
    }
    return ids;
}

const _setCreated = (units, indices) => {
    let i;
    for (i = 0; i < indices.length; i++) {
        units[indices[i]].created = true;
    }
}

const _setStarted = (units, indices) => {
    let i;
    for (i = 0; i < indices.length; i++) {
        units[indices[i]].started = true;
    }
}

const _setStopped = (units, indices) => {
    let i;
    for (i = 0; i < indices.length; i++) {
        units[indices[i]].started = false;
    }
}

const _setDestroyed = (units, indices) => {
    let i;
    for (i = 0; i < indices.length; i++) {
        units[indices[i]].created = false;
    }
}

const _storeToDestroy = (hash, units, indices, duration) => {
    for (let i = 0, u; i < indices.length; i++) {
        u = units[indices[i]];
        if (u.created) continue;
        if (typeof hash['tl_' + u.index] !== 'undefined') continue;
        hash['tl_' + u.index] = setTimeout(() => {

            _clearFromDestroyHash(hash, u);

            _destroyUnit(u);

        }, duration * 1000);
    }
}

const _undoStoreToDestroy = (hash, units, indices) => {
    let timeout;
    for (let i = 0, u; i < indices.length; i++) {
        u = units[indices[i]];
        if (typeof hash['tl_' + u.index] === void 0) continue;
        timeout = hash['tl_' + u.index];
        clearTimeout(timeout);
        hash['tl_' + u.index] = void 0;
    }
}

const _clearFromDestroyHash = (hash, unit) => {
    clearTimeout(hash['tl_' + unit.index]);
    delete hash['tl_' + unit.index];
}

const _destroyUnit = u => {
    u.created = false;
    u.started = false;
    u.timeline = null;
    u.destroy();
    u.resetCreatedChanged();
    u.resetStartedChanged();
}

const _createStarted = (units, indices, onSuccess) => {

    let i;
    let u;
    for (i = 0; i < indices.length; i++) {
        u = units[indices[i]];
        if (!u.created) continue;
        if (!u.started) continue;
        if (!u.createdChanged) {
            onSuccess(u);
            continue;
        }
        u.timeline = u.create();
        // TODO: actualize timeline duration ?
        u.resetCreatedChanged();
        u.resetStartedChanged();

        onSuccess(u);
    }

}

const _createCreated = (units, onSuccess) => {

    let i;
    let u;
    for (i = 0; i < units.length; i++) {
        u = units[i];
        if (!u.created || !u.createdChanged) continue;
        u.timeline = u.create();
        u.timeline.seek(0.0001);
        // TODO: actualize timeline duration ?
        u.resetCreatedChanged();

        onSuccess(u);
    }

}

const _doStop = (units, indices, onSuccess) => {

    let i;
    let u;
    for (i = 0; i < units.length; i++) {
        u = units[i];
        if (u.started) continue;
        if (!u.startedChanged) continue;
        u.resetStartedChanged();

        onSuccess(u);
    }

}

const _storeTimelineAtBunch = (tlUnit, bunch) => {
    bunch['tl_' + tlUnit.index] = {
        timeline: tlUnit.timeline,
        t0: tlUnit.t0,
        d: tlUnit.duration
    };
}

const _removeTimelineFromBunch = (tlUnit, bunch) => {
    bunch['tl_' + tlUnit.index] = null;
}

const _renderTimelineBunch = (bunch, t) => {
    let obj;
    let s;
    let t1;
    for (s in bunch) {
        if (!bunch.hasOwnProperty(s)) continue;
        obj = bunch[s];
        if (obj === null) continue;

        t1 = t - obj.t0;
        obj.timeline.seek(t1 <= 0 ? 0.001 : t1 >= obj.d ? obj.d - 0.001 : t1, false);
    }
}



/* /INTERNAL FUNCTIONS */

const defaults = {
    ease: Cubic.easeOut
};

class FlexTimeline extends EventEmitter {
    constructor(config) {
        super();

        // PROPERTIES

        this._params = Utils.extend(defaults, config);
        this._ease = this._params.ease;
        this._duration = 0;
        this._transition = 0;
        this._t = 0;
        this._destroyTimeoutDur = 3;

        // 1) FIRST STEP: storing constructors and destructors

        this._tlUnits = [];

        // AND time milestones to create and destroy and to start and stop render
        
        this._createHash = {
            forth: {
                sign: 1,
                todo: [],
                done: []
            },
            back: {
                sign: -1,
                todo: [],
                done: []
            }
        };
        this._startHash = {
            forth: {
                sign: 1,
                todo: [],
                done: []
            },
            back: {
                sign: -1,
                todo: [],
                done: []
            }
        };
        this._deleteHash = {
            forth: {
                sign: 1,
                todo: [],
                done: []
            },
            back: {
                sign: -1,
                todo: [],
                done: []
            }
        };


        // 2) SECOND STEP: adding to the render bunch of timelines

        this._timelineBunch = {};
        this._destroyTimeoutHash = {};


        // TODO: move private methods here

        this._updateTForth = value => {
            this._updateT(value, _updateHashForth, 'forth', 'back');
        };

        this._updateTBack = value => {
            this._updateT(value, _updateHashBack, 'back', 'forth');
        };

        this._playToTForth = value => {
            this._playToT(value, _updateHashForth, 'forth', 'back');
        };

        this._playToTBack = value => {
            this._playToT(value, _updateHashBack, 'back', 'forth');
        };
    }

    set realT(value) {
        if (this._t === value) return this._t;
        this._t = value;
        this._renderRealT();
        this.emit('update');
    }

    get realT() {
        return this._t;
    }

    set progress(value) {
        this.t = value * this._duration;
    }

    get progress() {
        return this._t / this._duration;
    }

    set transition(value) {
        this._transition = value;
    }

    get transition() {
        return this._transition;
    }

    set duration(value) {
        this._duration = value;
    }

    get duration() {
        return this._duration;
    }

    set ease(value) {
        this._ease = value || this._params.ease;
    }

    get ease() {
        return this._ease;
    }

    set t(value) {
        const newT = value < 0 ? 0 : value > this._duration ? this._duration : value;
        if (newT === this._t || newT === this._newT) return this._t;            // (this._t !== this._newT) ? this._newT :
        this._newT = newT;

        this._stopMove();

        const _update = this._newT > this._t ? this._updateTForth : this._updateTBack;
        _update.call(this, this._newT);
    }

    get t() {
        return this._t;
    }

    add(t, d, create, destroy, creationDelta) {
        if (t === void 0) return false;

        const unit = _getUnit(d, create, destroy, creationDelta);
        unit.t0 = t;
        unit.index = this._tlUnits.length;
        this._tlUnits.push(unit);

        _setTimeHash(this, t, unit.duration, unit.creationDelta, unit.index);

        _updateDuration(this, t + unit.duration);

        return true;
    }

    start() {
        this._updateTForth.call(this, this._t);
    }

    _updateT(value, _updateHash, updateByKey, sideUpdateKey) {
        const _storeTimeline = tl => { _clearFromDestroyHash(this._destroyTimeoutHash, tl); return _storeTimelineAtBunch(tl, this._timelineBunch); };
        const _removeTimeline = tl => { return _removeTimelineFromBunch(tl, this._timelineBunch); };
        const _clearFromDestroyHashTHIS = tl => { return _clearFromDestroyHash(this._destroyTimeoutHash, tl); };

        // 1) Update hashes
        const idsToCreate = _updateHash(this._createHash[updateByKey], value, 't');
        _updateHash(this._createHash[sideUpdateKey], value, 't');

        _setCreated(this._tlUnits, idsToCreate);
        _undoStoreToDestroy(this._destroyTimeoutHash, this._tlUnits, idsToCreate);


        const idsToStart = _updateHash(this._startHash[updateByKey], value, 't');
        _updateHash(this._startHash[sideUpdateKey], value, 't');

        _setStarted(this._tlUnits, idsToStart);


        const idsToChange = _updateHash(this._deleteHash[updateByKey], value, 't');
        _updateHash(this._deleteHash[sideUpdateKey], value, 't');

        _setStopped(this._tlUnits, idsToChange);
        _setDestroyed(this._tlUnits, idsToChange);

        // 2) Construct timelines: to draw and play
        _createStarted(this._tlUnits, idsToStart, _storeTimeline);

        // 3) Update timelines
        this.realT = value;

        _doStop(this._tlUnits, idsToChange, _removeTimeline);

        // 4) setTimeout to destroy unnecessary timelines
        _storeToDestroy(this._destroyTimeoutHash, this._tlUnits, idsToChange, this._destroyTimeoutDur);



        // 5) Pre-Construct timelines
        _createCreated(this._tlUnits, _clearFromDestroyHashTHIS);
    }

    playToT(value) {
        const newTTarget = value < 0 ? 0 : value > this._duration ? this._duration : value;

        if (newTTarget === this._newT) return;

        this._stopMove();
        this._newT = newTTarget;

        const _playToT = this._newT > this._t ? this._playToTForth : this._playToTBack;
        _playToT.call(this, this._newT);

    }

    _stopMove() {
        TweenMax.killTweensOf(this);
    }
    
    _playToT(value, _updateHash, updateByKey, sideUpdateKey) {
        const _storeTimeline = tl => { _clearFromDestroyHash(this._destroyTimeoutHash, tl); return _storeTimelineAtBunch(tl, this._timelineBunch); };

        // 1) Update hashes
        const idsToCreate = _updateHash(this._createHash[updateByKey], value, 't');
        _updateHash(this._createHash[sideUpdateKey], value, 't');

        _setCreated(this._tlUnits, idsToCreate);
        _undoStoreToDestroy(this._destroyTimeoutHash, this._tlUnits, idsToCreate);


        const idsToStart = _updateHash(this._startHash[updateByKey], value, 't');
        _updateHash(this._startHash[sideUpdateKey], value, 't');

        _setStarted(this._tlUnits, idsToStart);

        // 2) Construct timelines: to draw and play
        _createStarted(this._tlUnits, idsToStart, _storeTimeline);

        // 3) Update or ease timelines
        TweenMax.to(this, this._transition, {
            realT: value,
            ease: this._ease,
            onComplete: () => {
                this._afterPlayToT(value, _updateHash, updateByKey, sideUpdateKey);
            }
        });


    }

    _afterPlayToT(value, _updateHash, updateByKey, sideUpdateKey) {
        const _removeTimeline = tl => { return _removeTimelineFromBunch(tl, this._timelineBunch); };
        const _clearFromDestroyHashTHIS = tl => { return _clearFromDestroyHash(this._destroyTimeoutHash, tl); };


        // 4) setTimeout to destroy unnecessary timelines
        const idsToChange = _updateHash(this._deleteHash[updateByKey], value, 't');
        _updateHash(this._deleteHash[sideUpdateKey], value, 't');

        _setStopped(this._tlUnits, idsToChange);
        _setDestroyed(this._tlUnits, idsToChange);
        _doStop(this._tlUnits, idsToChange, _removeTimeline);
        _storeToDestroy(this._destroyTimeoutHash, this._tlUnits, idsToChange, this._destroyTimeoutDur);


        // 5) Pre-Construct timelines
        _createCreated(this._tlUnits, _clearFromDestroyHashTHIS);
    }

    _renderRealT() {
        _renderTimelineBunch(this._timelineBunch, this._t);
    }
}

module.exports = FlexTimeline;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/flexTimeline/FlexTimeline.js